import axios from "axios";
import http from "../helpers/http";

const getDomainFromUrl = () => {
  const { hostname } = window.location;

  if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }

  const cleanHost = hostname.replace(/^www\./, "");
  const firstPart = cleanHost.split(".")[0];
  if (!firstPart.includes("-")) {
    return null;
  }
  const domain = firstPart.split("-")[0];

  return domain || null;
};

export const signUp = async (payload) => {
  const response = await http().post("/account/register", payload);
  return response.data;
};

export const getBanks = async () => {
  const response = await http().get("/Account/GetBanks/banks");
  return response.data;
};

export const confirmEmail = async (payload) => {
  const response = await http().post("/account/confirmemail", payload);
  return response.data;
};

export const passwordChange = async (payload) => {
  const response = await http().post("/account/changepassword", payload);
  return response.data;
};
export const resetPasswordRequest = async (email) => {
  const response = await http().get(
    `/account/resetpasswordrequest?emailAddress=${email}`,
  );
  return response.data;
};
export const passwordReset = async (payload) => {
  const response = await http().post("/account/resetpassword", payload);
  return response.data;
};

export const completeMigration = async (payload) => {
  const domain = getDomainFromUrl();
  const response = await http().post(
    "/Merchant/CompleteMerchantMigration",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        ...(domain && { "X-Domain": domain }),
      },
    },
  );
  return response.data;
};

export const registerEmail = async (payload) => {
  const response = await http().post("/Account/RegisterEmail", payload);
  return response.data;
};
